/** URL base da API do GS3 */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "http://localhost:3001";

/** URL base do bucket de assets (logos, imagens, etc.) */
export const BUCKET_URL = import.meta.env.VITE_BUCKET_URL || "";

/** Chave da API do Google Maps */
export const GOOGLE_MAPS_API_KEY =
  import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "";

/** Map ID do Google Maps (obrigatório para Advanced Marker). */
export const GOOGLE_MAPS_MAP_ID =
  import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || "DEMO_MAP_ID";
